/*
 * "Vi har deg dekket" dialog. Spec: docs/pdp-spec.md § "Buy-box rebuild, 2026-09-16".
 *
 * Triggers: [data-value-open="<key>"] in snippets/kardima-value-props.liquid.
 * Dialog:   #KardimaValueModal from snippets/kardima-value-modal.liquid (body level).
 * The clicked promise is scrolled into view inside the panel and flashed once.
 *
 * Same open/close mechanics as assets/kardima-size-guide.js so both overlays behave alike.
 */
(function () {
  function init() {
    const modal = document.getElementById('KardimaValueModal');
    const backdrop = document.querySelector('[data-value-backdrop]');
    if (!modal || !backdrop) return;

    const panel = modal.querySelector('.kardima-value-modal__panel');
    let lastFocused = null;

    function open(event) {
      const key = event.currentTarget.getAttribute('data-value-open');
      lastFocused = document.activeElement;
      modal.hidden = false;
      backdrop.hidden = false;
      void panel.offsetWidth;
      modal.setAttribute('data-open', '');
      backdrop.setAttribute('data-open', '');
      document.body.classList.add('overflow-hidden');

      modal.querySelectorAll('[data-highlight]').forEach((el) => el.removeAttribute('data-highlight'));
      const entry = key ? modal.querySelector('[data-value-entry="' + key + '"]') : null;
      if (entry) {
        entry.setAttribute('data-highlight', '');
        // Scroll the panel, not the page: the page is locked while the dialog is open.
        panel.scrollTop = Math.max(0, entry.offsetTop - panel.offsetTop - 16);
      } else {
        panel.scrollTop = 0;
      }

      const close = modal.querySelector('[data-value-close]');
      if (close) close.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function hide() {
      modal.removeAttribute('data-open');
      backdrop.removeAttribute('data-open');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKeydown);

      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        modal.hidden = true;
        backdrop.hidden = true;
        if (lastFocused && lastFocused.focus) lastFocused.focus();
      };
      panel.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 400);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') hide();
    }

    // Dawn re-renders the buy box on variant change, so bind on the document, not on nodes.
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-value-open]');
      if (!trigger) return;
      event.preventDefault();
      open({ currentTarget: trigger });
    });
    modal.querySelectorAll('[data-value-close]').forEach((el) => el.addEventListener('click', hide));
    backdrop.addEventListener('click', hide);
    modal.addEventListener('click', (event) => {
      if (!panel.contains(event.target)) hide();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
